(ns pfo.chat.common-component
  (:require
   [clojure.string :as str]
   [reagent.core :as r]
   [pfo.api :as api]
   [pfo.util :as util]
   [pfo.download :as download]
   ["react-markdown" :default ReactMarkdown]
   ["remark-gfm" :default remarkGfm]
   ["rehype-highlight" :default rehypeHighlight]))

(defn- artifact-download-id
  "The artifact a link points at, or nil for every other link.

  Deliberately narrow: this is the only href the chat treats as its own, and any link the
  model writes for anything else must reach the browser untouched. The origin is part of
  the test -- a link to another environment ends in the same path, and answering it here
  would hand out a local file under a link that visibly points elsewhere."
  [href]
  (let [href (or href "")]
    (when (or (str/starts-with? href "#/")
              (str/starts-with? href (str (.-origin (.-location js/window)) "/#/")))
      (second (re-find #"#/artifact/(\d+)/download$" href)))))

(defn- markdown-link
  "Renders a link in an assistant message, saving the file in place when the link is a
  download of a file AARK created.

  The href is kept, so hovering shows a real URL and a modified click still opens a tab,
  where the route saves the file instead. Only a plain click is intercepted, and only for
  our own path: it keeps the user in the conversation, which a route change does not --
  entering the app afresh costs a full boot and its event streams."
  [props]
  (let [href (.-href props)
        artifact-id (artifact-download-id href)]
    (r/create-element "a"
      #js {:href href
           ;; Carried over rather than dropped: a markdown link may set it
           ;; ([text](url "title")) and the tooltip is the reader's only hint.
           :title (.-title props)
           :onClick (when artifact-id
                      (fn [e]
                        (when (util/plain-click? e)
                          (.preventDefault e)
                          (-> (download/fetch-and-save-file
                                (str "/chat/artifact/" artifact-id "/download"))
                              (.catch #(api/handle-error-response nil % nil))))))}
      (.-children props))))

(defn markdown-message [_ message]
  [:> ReactMarkdown
   {:children message
    :components #js {:a markdown-link}
    :remarkPlugins #js [remarkGfm]
    :rehypePlugins #js [rehypeHighlight]}])

(defn add-sidebar-panel [*sidebar-panels panel-options panel-id panel-title component]
  (swap! *sidebar-panels assoc
    panel-id
    {:config (merge {:title panel-title} panel-options)
     :component component})
  [;; remove fn
   (fn [] (swap! *sidebar-panels dissoc panel-id))
   ;; open/close fn
   (fn [open] (swap! *sidebar-panels assoc-in [panel-id :open] open))])
